import {IconProps, darkGray, gray, orange, white} from './shared';

export const Bad = ({selected}: IconProps) => {
  const backgroundColor = selected ? orange : gray;
  const foregroundColor = selected ? darkGray : white;
  const backgroundOpacity = selected ? '1.0' : '0.7';

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z"
        fill={backgroundColor}
        opacity={backgroundOpacity}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6261 28.243C14.1766 28.7552 12.9221 29.3689 12.233 29.7626C11.6336 30.1051 10.8701 29.8969 10.5276 29.2975C10.1851 28.6981 10.3933 27.9345 10.9927 27.592C11.809 27.1255 13.1997 26.4489 14.7932 25.8858C16.374 25.3272 18.2478 24.8467 20 24.8467C21.7521 24.8467 23.6259 25.3272 25.2068 25.8858C26.8003 26.4489 28.1909 27.1255 29.0072 27.592C29.6066 27.9345 29.8149 28.6981 29.4724 29.2975C29.1299 29.8969 28.3663 30.1051 27.7669 29.7626C27.0778 29.3689 25.8233 28.7552 24.3738 28.243C22.9116 27.7263 21.3446 27.3467 20 27.3467C18.6553 27.3467 17.0883 27.7263 15.6261 28.243Z"
        fill={foregroundColor}
      />
      <path
        d="M15.4838 13.8386C15.4838 15.6202 14.0396 17.0644 12.258 17.0644C10.4765 17.0644 9.03223 15.6202 9.03223 13.8386C9.03223 12.057 10.4765 10.6128 12.258 10.6128C14.0396 10.6128 15.4838 12.057 15.4838 13.8386Z"
        fill={foregroundColor}
      />
      <path
        d="M30.9677 13.8386C30.9677 15.6202 29.5235 17.0644 27.7419 17.0644C25.9603 17.0644 24.5161 15.6202 24.5161 13.8386C24.5161 12.057 25.9603 10.6128 27.7419 10.6128C29.5235 10.6128 30.9677 12.057 30.9677 13.8386Z"
        fill={foregroundColor}
      />
    </svg>
  );
};
